import { SyntheticEvent, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useAppSelector from "@/core/helpers/useAppSelector";
import { Modal } from "@/shared/ui";
import { safetySelector } from "@/domains/account/slice";
import { validateEmail } from "@/domains/playerMenu/helpers/validateEmail";
import useEmailCode from "@/domains/playerMenu/hooks/useEmailCode";
import PlayerMenuSettingsSafetyEnableTfaEmailCheckContainer from "@/domains/playerMenu/containers/settings/safety/tfa/check-enable/PlayerMenuSettingsSafetyEnableTfaEmailCheckContainer";
import PlayerMenuSettingsSafetyEnableTfaEmailSend from "@/domains/playerMenu/components/settings/safety/tfa/PlayerMenuSettingsSafetyEnableTfaEmailSend";

type Props = {
  onClose: () => void;
};

export default function PlayerMenuSettingsSafetyEnableTfaEmailContainer({ onClose }: Props) {
  const { t } = useTranslation("account");
  const { sendError, sendCodeHandler, sendIsPending, sendIsCompleted } = useEmailCode();
  const { email } = useAppSelector(safetySelector);
  const [emailError, setEmailError] = useState<string>("");

  useEffect(() => {
    if (email) {
      const validateError = validateEmail(email);
      if (validateError) {
        setEmailError(validateError);
        return;
      }
    }
    setEmailError("");
  }, [email]);

  const onSubmit = useCallback(
    async (e: SyntheticEvent<HTMLFormElement>) => {
      e.preventDefault();
      if (emailError) return;
      sendCodeHandler(email);
    },
    [email, emailError],
  );

  const title = t(sendIsCompleted ? "account.confirmTfaEmail" : "account.enableTfaEmail");

  return (
    <Modal open onClose={onClose} title={title} className="h-[49rem]">
      {sendIsCompleted ? (
        <PlayerMenuSettingsSafetyEnableTfaEmailCheckContainer address={email} onClose={onClose} />
      ) : (
        <PlayerMenuSettingsSafetyEnableTfaEmailSend
          error={emailError || sendError}
          onSubmit={onSubmit}
          email={email}
          pending={sendIsPending}
        />
      )}
    </Modal>
  );
}
